import React, { useState, useRef } from "react";
import { useDraggable } from "react-use-draggable-scroll";
import nextId from "react-id-generator";

import PropTypes from "prop-types";

import { Select } from "shared/Select/Select";
import Button from "shared/Button";
import Input from "shared/@forms/Input";

import styles from "./CreateNote.module.css";
import classNames from "classnames";

import FileUploader from "../FileUploader";
import { Upload } from "react-ikonate";

/**
 *
 * A form to send case-related emails. List of the case’s email history displayed to the right with a btn to preview the sent email.
 *
 */

export function CreateNote({ notes, onSubmit, onImageClick }) {
  const [fileList, setFileList] = useState([]);

  const ref = useRef(); // We will use React useRef hook to reference the wrapping div:
  const { events } = useDraggable(ref, {
    applyRubberBandEffect: true,
  }); // Now we pass the reference to the useDraggable hook:
  const draggerId = "adminsDraggerId" + nextId();

  const [title, setTitle] = useState("");
  const [text, setText] = useState("");

  function handleForm(e) {
    const files = [...e.target.files];
    setFileList([...files]);
  }

  return (
    <div className={styles.container}>
      <div className={styles.left}>
        <div className={styles.title}>Create Note</div>

        <div>
          <Input
            className={styles.input}
            placeholder="Note Title"
            defaultValue={title}
            //value={email.subject || ""}
            onChange={(e) => {
              setTitle(e.target.value);
            }}
          />
        </div>

        <div className={styles.textAreaContainer}>
          <textarea
            className={styles.textArea}
            placeholder="Add text here..."
            defaultValue={text}
            //value={email.body || ""}
            onChange={(e) => setText(e.target.value)}
          />
        </div>
        <div className={styles.actionBar}>
          <div className={styles.fileUploadContainer}>
            <label htmlFor="fileUpload" className={styles.fileUpload}>
              {fileList.length === 0
                ? "Attach Files"
                : fileList.map((file, index) =>
                    index === fileList.length - 1
                      ? `${file.name}`
                      : `${file.name}, `
                  )}
              <span className={styles.uploadIcon}>
                <Upload />
              </span>
            </label>
            <input
              className={styles.fileUpload}
              type="file"
              id="fileUpload"
              onChange={(e) => handleForm(e)}
              multiple
            />
          </div>
          <Button
            className={styles.button}
            onClick={() => {
              onSubmit({ title: title, text: text, files: fileList });
            }}
          >
            Submit
          </Button>
        </div>
      </div>

      <div className={styles.right}>
        <div className={styles.title}>Notes</div>
        <div
          className={classNames(styles.notesContainer, styles.dragger)}
          {...events}
          ref={ref}
          id={draggerId}
        >
          {notes.map((item, index) => (
            <div className={styles.noteContainer} key={index}>
              <div className={styles.noteDate}>{item.date}</div>
              <div className={styles.noteName}>{item.name}</div>
              <div className={styles.noteDescription}>{item.description}</div>
              {item.files && item.files.length > 0 && (
                <div className={styles.imageRow}>
                  {item.files.map((file) => {
                    return (
                      <p onClick={() => onImageClick(file)}>{file.name}</p>
                    );
                  })}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

CreateNote.propTypes = {
  notes: PropTypes.arrayOf(PropTypes.object),
};
